import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute/PrivateRoute';
import CreateAccount from '../pages/Auth/CreateAccount/CreateAccount';
import CreateMicrosoftAccount from '../pages/Auth/CreateMicrosoftAccount/CreateMicrosoftAccount';
import ForgotPassword from '../pages/Auth/ForgotPassword/ForgotPassword';
import Login from '../pages/Auth/Login/Login';
import LoginSSO from '../pages/Auth/LoginSSO/LoginSSO';
import ChallengesMain from '../pages/Challenges/ChallengesMain/ChallengesMain';
import CreateChallenge from '../pages/Challenges/CreateChallenge/CreateChallenge';
import CollaboratorDetails from '../pages/CollaboratorDetails/CollaboratorDetails';
import Collaborators from '../pages/Collaborators/Collaborators';
import HomeNE from '../pages/HomeNE/HomeNE';
import HealthReport from '../pages/Landings/Reports/HealthReport/HealthReport';
import AddCollaboratorsDependents from '../pages/ManageCollaborators/AddCollaboratorsDependents/AddCollaboratorsDependents';
import DeleteSubscriptions from '../pages/ManageCollaborators/DeleteSubscriptions/DeleteSubscriptions';
import ManageCollaboratorActions from '../pages/ManageCollaborators/ManageCollaboratorActions/ManageCollaboratorActions';
import SubscribeCollaborators from '../pages/ManageCollaborators/SubscribeCollaborators/SubscribeCollaborators';
import MetricsNE from '../pages/MetricsNE/MetricsNE';
import BenefitDetail from '../pages/Plans/BenefitDetail/BenefitDetail';
import BenefitsToChoose from '../pages/Plans/BenefitsToChoose/BenefitsToChoose';
import InsuranceDetail from '../pages/Plans/InsuranceDetail/InsuranceDetail';
import MyPlan from '../pages/Plans/MyPlan/MyPlan';
import Reports from '../pages/Reports/Reports';
import RequestDetails from '../pages/Requests/RequestDetails/RequestDetails';
import RequestsTable from '../pages/Requests/RequestsTable/RequestsTable';
import RewardsPointsByFile from '../pages/Rewards/RewadsPointsByFile/RewardsPointsByFile';
import RewardsHistory from '../pages/Rewards/RewardsHistory/RewardsHistory';
import RewardsHistoryDetails from '../pages/Rewards/RewardsHistoryDetails/RewardsHistoryDetails';
import RewardsLoadBalance from '../pages/Rewards/RewardsLoadBalance/RewardsLoadBalance';
import RewardsPoints from '../pages/Rewards/RewardsPoints/RewardsPoints';
import RewardsPointsConfig from '../pages/Rewards/RewardsPointsConfig/RewardsPointsConfig';
import BalanceCharge from '../pages/RF/BalanceCharge/BalanceCharge';
import SettingsAccount from '../pages/Settings/SettingsAccount/SettingsAccount';
import SettingsIntegrations from '../pages/Settings/SettingsIntegrations/SettingsIntegrations';
import SettingsOrganizationNE from '../pages/Settings/SettingsOrganizationsNE/SettingsOrganizationNE';
import StoriesCreateNew from '../pages/Stories/StoriesCreateNew/StoriesCreateNew';
import StoriesList from '../pages/Stories/StoriesList/StoriesList';
import {
  METRICS_NE_ROUTE,
  LOGIN_ROUTE,
  RESET_PASSWORD_ROUTE,
  HOME_ROUTE,
  INTEGRATIONS_ROUTE,
  PLAN_ROUTE,
  LOGIN_SSO_ROUTE,
  COLLABORATORS_HOME_ROUTE,
  SIGN_UP_ROUTE,
  NEW_CHANGE_ORGANIZATION_ROUTE,
  ACCOUNT_ROUTE,
  STORIES_ROUTE,
  NEW_STORY_ROUTE,
  LOAD_BALANCE_ROUTE,
  REWARDS_POINTS_ROUTE,
  REWARDS_POINTS_CONFIG_ROUTE,
  REWARDS_HISTORY_DETAILS_ROUTE,
  REWARDS_HISTORY_ROUTE,
  REWARDS_POINTS_FILE_ROUTE,
  CHALLENGES_MAIN_ROUTE,
  CREATE_CHALLENGE_ROUTE,
  MANAGE_COLLABORATORS_ROUTE,
  COLLABORATOR_DETAIL_ROUTE,
  BENEFIT_DETAIL_ROUTE,
  INSURANCE_DETAIL_ROUTE,
  BENEFITS_TO_CHOOSE_ROUTE,
  BALANCE_CHARGE_ROUTE,
  REPORTS_ROUTE,
  DELETE_COLLABORATORS_ROUTE,
  ADD_COLLABORATORS_ROUTE,
  COLLABORATORS_ADD_DEPENDENTS_ROUTE,
  LANDING_HEALTH_REPORT_ROUTE,
  REQUEST_TABLE_ROUTE,
  REQUEST_DETAIL_ROUTE,
  MICROSOFT_SIGN_UP_ROUTE
} from '../shared/constants/auth';
import { PERMISSIONS_BY_ROUTE } from '../shared/constants/permissions';
import MetricsContextProvider from '../shared/context/metrics/metricsContext';
import RewardsContextProvider from '../shared/context/rewards/rewardsContext';
import StoriesContextProvider from '../shared/context/stories/storiesContext';

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path={HOME_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[HOME_ROUTE]}>
            <HomeNE />
          </PrivateRoute>
        }
      />
      <Route
        path={METRICS_NE_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[METRICS_NE_ROUTE]}>
            <MetricsContextProvider>
              <MetricsNE />
            </MetricsContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={COLLABORATOR_DETAIL_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[COLLABORATOR_DETAIL_ROUTE]}>
            <CollaboratorDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={COLLABORATORS_HOME_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[COLLABORATORS_HOME_ROUTE]}>
            <Collaborators />
          </PrivateRoute>
        }
      />
      <Route
        path={BENEFITS_TO_CHOOSE_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[BENEFITS_TO_CHOOSE_ROUTE]}>
            <BenefitsToChoose />
          </PrivateRoute>
        }
      />
      <Route
        path={PLAN_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[PLAN_ROUTE]}>
            <MyPlan />
          </PrivateRoute>
        }
      />
      <Route
        path={STORIES_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[STORIES_ROUTE]}>
            <StoriesContextProvider>
              <StoriesList />
            </StoriesContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={NEW_STORY_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[NEW_STORY_ROUTE]}>
            <StoriesContextProvider>
              <StoriesCreateNew />
            </StoriesContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={INTEGRATIONS_ROUTE}
        element={
          <PrivateRoute>
            <SettingsIntegrations />
          </PrivateRoute>
        }
      />
      <Route
        path={NEW_CHANGE_ORGANIZATION_ROUTE}
        element={
          <PrivateRoute>
            <SettingsOrganizationNE />
          </PrivateRoute>
        }
      />
      <Route
        path={ACCOUNT_ROUTE}
        element={
          <PrivateRoute>
            <SettingsAccount />
          </PrivateRoute>
        }
      />
      <Route
        path={LOAD_BALANCE_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[LOAD_BALANCE_ROUTE]}>
            <RewardsContextProvider>
              <RewardsLoadBalance />
            </RewardsContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={REWARDS_POINTS_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[REWARDS_POINTS_ROUTE]}>
            <RewardsContextProvider>
              <RewardsPoints />
            </RewardsContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={REWARDS_POINTS_CONFIG_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[REWARDS_POINTS_CONFIG_ROUTE]}>
            <RewardsContextProvider>
              <RewardsPointsConfig />
            </RewardsContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={REWARDS_POINTS_FILE_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[REWARDS_POINTS_FILE_ROUTE]}>
            <RewardsContextProvider>
              <RewardsPointsByFile />
            </RewardsContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={REWARDS_HISTORY_DETAILS_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[REWARDS_HISTORY_DETAILS_ROUTE]}>
            <RewardsContextProvider>
              <RewardsHistoryDetails />
            </RewardsContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={REWARDS_HISTORY_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[REWARDS_HISTORY_ROUTE]}>
            <RewardsContextProvider>
              <RewardsHistory />
            </RewardsContextProvider>
          </PrivateRoute>
        }
      />
      <Route
        path={CHALLENGES_MAIN_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[CHALLENGES_MAIN_ROUTE]}>
            <ChallengesMain />
          </PrivateRoute>
        }
      />
      <Route
        path={CREATE_CHALLENGE_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[CREATE_CHALLENGE_ROUTE]}>
            <CreateChallenge />
          </PrivateRoute>
        }
      />

      <Route
        path={MANAGE_COLLABORATORS_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[MANAGE_COLLABORATORS_ROUTE]}>
            <ManageCollaboratorActions />
          </PrivateRoute>
        }
      />
      <Route
        path={DELETE_COLLABORATORS_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[MANAGE_COLLABORATORS_ROUTE]}>
            <DeleteSubscriptions />
          </PrivateRoute>
        }
      />
      <Route
        path={ADD_COLLABORATORS_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[MANAGE_COLLABORATORS_ROUTE]}>
            <SubscribeCollaborators />
          </PrivateRoute>
        }
      />
      <Route
        path={COLLABORATORS_ADD_DEPENDENTS_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[MANAGE_COLLABORATORS_ROUTE]}>
            <AddCollaboratorsDependents />
          </PrivateRoute>
        }
      />

      <Route
        path={BENEFIT_DETAIL_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[BENEFIT_DETAIL_ROUTE]}>
            <BenefitDetail />
          </PrivateRoute>
        }
      />
      <Route
        path={INSURANCE_DETAIL_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[INSURANCE_DETAIL_ROUTE]}>
            <InsuranceDetail />
          </PrivateRoute>
        }
      />
      <Route
        path={BALANCE_CHARGE_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[BALANCE_CHARGE_ROUTE]}>
            <BalanceCharge />
          </PrivateRoute>
        }
      />
      <Route
        path={REPORTS_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[REPORTS_ROUTE]}>
            <Reports />
          </PrivateRoute>
        }
      />
      <Route
        path={LANDING_HEALTH_REPORT_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[LANDING_HEALTH_REPORT_ROUTE]}>
            <HealthReport />
          </PrivateRoute>
        }
      />
      <Route
        path={REQUEST_TABLE_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[REQUEST_TABLE_ROUTE]}>
            <RequestsTable />
          </PrivateRoute>
        }
      />
      <Route
        path={REQUEST_DETAIL_ROUTE}
        element={
          <PrivateRoute permissionsRequired={PERMISSIONS_BY_ROUTE[REQUEST_DETAIL_ROUTE]}>
            <RequestDetails />
          </PrivateRoute>
        }
      />

      <Route path={RESET_PASSWORD_ROUTE} element={<ForgotPassword />} />
      <Route path={LOGIN_ROUTE} element={<Login />} />
      <Route path={LOGIN_SSO_ROUTE} element={<LoginSSO />} />
      <Route path={SIGN_UP_ROUTE} element={<CreateAccount />} />
      <Route path={MICROSOFT_SIGN_UP_ROUTE} element={<CreateMicrosoftAccount />} />

      <Route path="*" element={<Navigate to={HOME_ROUTE} replace />} />
    </Routes>
  );
};

export default AppRoutes;
